import PropTypes from 'prop-types';
import React from 'react';
import FileThumbnail from '@unite-us/client-utils/dist/FileThumbnail';
var FilePreview = function FilePreview(_ref) {
  var contentType = _ref.contentType,
    preview = _ref.preview;
  if (/\bimage\b/.test(contentType)) {
    return /*#__PURE__*/React.createElement("img", {
      src: preview,
      alt: "preview"
    });
  }
  return /*#__PURE__*/React.createElement(FileThumbnail, {
    contentType: contentType
  });
};
FilePreview.propTypes = {
  contentType: PropTypes.string.isRequired,
  preview: PropTypes.string
};
export default FilePreview;
//# sourceMappingURL=FilePreview.js.map